export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8281.3eccef36.jpg";